const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Fashionable%20female%20entertainment%20figure%20wearing%20sunglasses%20at%20airport%2C%20paparazzi%20style%20photography%2C%20warm%20natural%20light%2C%20casual%20chic%20outfit%2C%20blurred%20background%20with%20crowd%2C%20editorial%20street%20photography&width=800&height=560&seq=card-1-51cg-2026&orientation=landscape',
    title: '某女星机场私服造型引热议，时尚品味获赞',
    desc: '低调出行的她一身简约穿搭反而成了全场焦点，网友直呼太会穿了。',
    category: '明星动态',
    time: '2小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20restaurant%20interior%20with%20warm%20candlelight%2C%20elegant%20dining%20scene%2C%20intimate%20atmosphere%2C%20private%20dinner%20setting%2C%20romantic%20ambiance%2C%20fine%20dining%20photography&width=800&height=560&seq=card-2-51cg-2026&orientation=landscape',
    title: '深夜聚餐被拍！某男星与神秘友人相谈甚欢',
    desc: '聚餐结束后两人一同乘车离开，引发外界对关系猜测。',
    category: '独家爆料',
    time: '5小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20production%20set%20with%20bright%20lights%20and%20cameras%2C%20variety%20show%20recording%20atmosphere%2C%20professional%20crew%20working%2C%20entertainment%20production%20environment&width=800&height=560&seq=card-3-51cg-2026&orientation=landscape',
    title: '某综艺录制突遭变故，节目组连夜调整方案',
    desc: '据现场工作人员透露，嘉宾之间的意外冲突导致录制计划被打乱。',
    category: '综艺热点',
    time: '8小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20shopping%20mall%20interior%20with%20high-end%20brand%20stores%2C%20elegant%20architecture%2C%20warm%20ambient%20lighting%2C%20upscale%20retail%20environment%2C%20fashionable%20shoppers%20in%20distance&width=800&height=560&seq=card-4-51cg-2026&orientation=landscape',
    title: '品牌代言换人？某当红小生或将接手千万代言',
    desc: '此前该品牌的代言合约即将到期，新一任代言人选成为关注焦点。',
    category: '商业八卦',
    time: '12小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20dramatic%20spotlights%20and%20crowd%2C%20live%20performance%20atmosphere%2C%20energetic%20concert%20photography%2C%20warm%20golden%20and%20red%20stage%20lighting%2C%20entertainment%20event&width=800&height=560&seq=card-5-51cg-2026&orientation=landscape',
    title: '演唱会风波：粉丝质疑主办方票务不透明',
    desc: '开票瞬间即售罄引发争议，大量粉丝投诉无法正常购买门票。',
    category: '粉丝声音',
    time: '1天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门图文
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">最新最热的图文爆料，吃瓜不吃哑巴瓜</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/30 transition-colors group flex flex-col ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              {/* Image */}
              <div className={`relative w-full overflow-hidden ${idx === 0 ? 'aspect-[16/9] md:aspect-[16/8]' : 'aspect-[4/3]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded whitespace-nowrap">
                  {item.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-4 flex-1 flex flex-col">
                <h3 className={`font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 ${
                  idx === 0 ? 'text-lg' : 'text-sm md:text-base'
                }`}>
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-500">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}